import type { GetState } from 'types/redux'
import type { TempItem } from 'types/shortlist'
import { mapResponseToReducerObjects } from '@disco/state-management/actions/PlaylistTrackActions'
import {
  removeTempItem,
  updateTempItem,
} from '@disco/state-management/actions/ShortlistActions'
import { uploadFile } from '@disco/utils/upload'
export const uploadShortlistFile = (
  dispatch: (...args: Array<any>) => any,
  getState: GetState,
  csrfToken: string,
  shortlistId: string,
  tempItem: TempItem,
  abortSignal: AbortSignal,
): any => {
  return uploadFile(
    tempItem.file,
    csrfToken,
    tempItem.tempId,
    {
      onInfoParse(info) {
        dispatch(updateTempItem(shortlistId, info))
      },

      onDuplicateFound(track, tempTrack) {
        const normalizedTrack = mapResponseToReducerObjects(
          dispatch,
          getState,
          track,
        )
        dispatch(
          updateTempItem(
            shortlistId,
            { ...normalizedTrack, tempId: tempTrack.tempId },
            true,
          ),
        )
      },

      onUploadProgress(tempTrack) {
        dispatch(
          updateTempItem(shortlistId, {
            ...tempTrack,
            status: tempTrack.progress === 100 ? 'processing' : undefined,
          }),
        )
      },

      onUploadError(tempTrack) {
        dispatch(removeTempItem(shortlistId, tempTrack))
      },

      onUploadDone(track, tempTrack) {
        const { title, artist, album } = tempTrack
        // if uploaded is not set, that means that server didn't read tags
        // yet, use parsed tags from frontend instead
        const adjustedTrack = track.uploaded
          ? { ...track, uploadId: tempTrack.tempId }
          : {
              ...track,
              name: title,
              artist,
              album,
              ext: tempItem.ext,
              uploadId: tempTrack.tempId,
            }
        const normalizedTrack = mapResponseToReducerObjects(
          dispatch,
          getState,
          adjustedTrack,
        )
        dispatch(
          updateTempItem(
            shortlistId,
            { ...normalizedTrack, tempId: tempTrack.tempId },
            true,
          ),
        )
      },
    },
    null,
    {},
    abortSignal,
  )
}
